module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-05-15 at 10.31.49 AM.d34bef0d.png";